import { render, staticRenderFns } from "./MappingTable.vue?vue&type=template&id=6b655f9e&"
import script from "./MappingTable.vue?vue&type=script&lang=js&"
export * from "./MappingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports